import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import AstronautsBottomSheet from '@/modals/AstronautsBottomSheet/AstronautsBottomSheet';
const RequireBuildingAccessibilityBottomSheet = ({ isVisible, onPressCloseButton, onPressConfirmButton, isFirstFloor, }) => {
    return (_jsx(AstronautsBottomSheet, { isVisible: isVisible, title: isFirstFloor
            ? '정복할 수 있는\n건물을 발견했어요!'
            : '높은 곳에 있는 장소를\n정복했어요!', confirmButtonText: isFirstFloor ? '건물 정복하기' : '정보 등록하기', onPressConfirmButton: onPressConfirmButton, closeButtonText: "\uB098\uC911\uC5D0", onPressCloseButton: onPressCloseButton, children: isFirstFloor ? (_jsx(Message, { children: "\uC774 \uAC74\uBB3C\uB3C4 \uC9C0\uAE08 \uBC14\uB85C \uC815\uBCF5\uD560\uAE4C\uC694?" })) : (_jsxs(Message, { children: ['이 장소에 가려면\n', _jsx(Emphasis, { children: "\uC5D8\uB9AC\uBCA0\uC774\uD130, \uC785\uAD6C \uC815\uBCF4" }), '가 꼭 필요해요.\n', "\uC9C0\uAE08 \uBC14\uB85C\uB4F1\uB85D\uD560\uAE4C\uC694?"] })) }));
};
export default RequireBuildingAccessibilityBottomSheet;
const Message = styled.Text({
    fontSize: 20,
    fontFamily: font.pretendardBold,
    color: 'black',
    lineHeight: '32px',
    fontWeight: 'bold',
    textAlign: 'center',
    letterSpacing: -0.5,
});
const Emphasis = styled(Message)({
    color: color.brandColor,
});
